var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"down-top-padding",attrs:{"fluid":""}},[_c('h1',[_vm._v("Нет доступа для просмотра контента")])])}
var staticRenderFns = []

export { render, staticRenderFns }